/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ElectricityConsumption;
(function (ElectricityConsumption) {
    /**
     * Unit, `kWh` for kilowatt-hours, `MWh` for megawatt-hours, `GWh` for gigawatt-hours
     */
    let unit;
    (function (unit) {
        unit["K_WH"] = "kWh";
        unit["MWH"] = "MWh";
        unit["GWH"] = "GWh";
    })(unit = ElectricityConsumption.unit || (ElectricityConsumption.unit = {}));
})(ElectricityConsumption || (ElectricityConsumption = {}));
//# sourceMappingURL=ElectricityConsumption.js.map